import { storefrontInventoryServicesHttpClient } from '../../utils/HttpClient'

import { setInventoryInSessionStorage } from './inventory.sessionStorage'
export interface InventoryResponce {
  available: number
  locationId: number
  inventoryType: string
  tags: {
    preOrderShippingDate: string
  } | null
  vendorCode: string
  isInventoryPresentAtSFWarehouse?: boolean
}

const ERROR_API_CALL_TO_GET_INVENTORY = 'Error API call to get inventory'
interface GetInventoryOptions {
  data?: any
  code?: number
  message?: string
  statusText?: string
  [key: string]: any
}

export async function getInventory({ storeResultInStorage = false, ...params }: GetInventoryOptions) {
  try {
    const { data, status } = await storefrontInventoryServicesHttpClient.get('/active-inventory', {
      params,
    })
    if (storeResultInStorage) {
      setInventoryInSessionStorage({ data, code: status })
    }
    return data
  } catch (e: any) {
    console.error('Failed while fetching getInventory(), API - `/carts/${cartId}`', e)
    if (storeResultInStorage) {
      setInventoryInSessionStorage({
        data: {},
        code: e?.code,
        message: e?.message ?? e?.message ?? String(e),
        statusText: ERROR_API_CALL_TO_GET_INVENTORY,
      })
    }
    if (e?.toString() === 'AxiosError: Network Error' && e?.code === 'ERR_NETWORK') return { isCorsError: true }
    return {}
  }
}
